import styled from "styled-components";

export default styled.div`
  display: flex;
  
  justify-content: center;
  align-items: center;
  height: 260px;
  width: 100%;
  background-color: #EFF2F4;
  margin: 0 15px;
 
  
  
 
`;